const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#0a1628]"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3dd3f02f3a80ec3cf18914df4848ba4f.jpg"
          alt="Campus Négus Tech formation"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628] via-[#0a1628]/80 to-[#0a1628]/40"></div>
      </div>

      {/* Decorative yellow accent */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#f5c518]/10 to-transparent pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left Content */}
          <div className="flex-1 max-w-2xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#f5c518]/20 border border-[#f5c518]/40 rounded-full px-4 py-2 mb-8">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-[#f5c518] text-sm"></i>
              </div>
              <span className="text-[#f5c518] text-sm font-semibold">Inscriptions ouvertes — Kinshasa</span>
            </div>

            {/* Title */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
              Campus négus tech&nbsp;<br />
              <span className="text-[#f5c518]">Apprendre un métier en quelques mois et commencer à travailler&nbsp;</span>
            </h1>

            {/* Subtitle */}
            <p className="text-white/75 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
              Campus Négus Tech vous offre des formations professionnelles certifiées en électricité, solaire, fibre optique, GSM, système d'alarme sécurité &amp; vidéosurveillance, web, IA et business à Kinshasa.
            </p>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 mb-10">
              {[
                { value: '500+', label: 'Étudiants formés' },
                { value: '8', label: 'Filières disponibles' },
                { value: '95%', label: 'Taux d\'insertion' },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-[#f5c518] text-3xl font-black">{stat.value}</div>
                  <div className="text-white/60 text-sm mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 bg-[#f5c518] text-[#0a1628] font-bold text-base px-8 py-4 rounded-full hover:bg-yellow-400 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center bg-[#0a1628] rounded-full">
                  <i className="ri-whatsapp-line text-[#f5c518] text-sm"></i>
                </div>
                S'inscrire via WhatsApp
              </a>
              <a
                href="#formations"
                className="flex items-center justify-center gap-2 border-2 border-white/40 text-white font-semibold text-base px-8 py-4 rounded-full hover:border-[#f5c518] hover:text-[#f5c518] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Voir les formations
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-sm"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden lg:block flex-shrink-0 w-[420px] relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/62a60f89901dfbfa5f982ec0ed5c3418.png"
                alt="Étudiants en formation"
                className="w-full h-[560px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/60 to-transparent"></div>
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -left-6 bg-[#f5c518] rounded-2xl px-5 py-4 shadow-xl">
              <div className="text-[#0a1628] font-black text-2xl">500+</div>
              <div className="text-[#0a1628]/70 text-xs font-semibold">Diplômés</div>
            </div>
            <div className="absolute top-6 -right-4 bg-white rounded-xl px-4 py-3 shadow-xl">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <div className="text-[#0a1628] font-bold text-xs">Certifié</div>
                  <div className="text-gray-500 text-xs">Professionnel</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 text-lg"></i>
        </div>
      </div>
    </section>
  );
}
